var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.text),expression:"!!text"},{name:"dbclick",rawName:"v-dbclick"}],staticClass:"copy-btn",attrs:{"type":_vm.buttonType},on:{"click":function($event){$event.stopPropagation();return _vm.handleCopyBtn.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.realBtnText))])
}
var staticRenderFns = []

export { render, staticRenderFns }